import { configureStore } from "@reduxjs/toolkit";
import billingReducer from "./slices/billingSlice";
import patientVisitReducer from "./slices/patientVisitSlice";
import prescriptionReducer from "./slices/prescriptionSlice";

export const store = configureStore({
  reducer: {
    patientVisit: patientVisitReducer,
    billing: billingReducer,
    prescription: prescriptionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
